import ExportDatesRange from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportDatesRange'
import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const UsedTimeoffFields = ({ form }: Props) => {
  return (
    <>
      <ExportEmployeeSelector form={form} />
      <ExportDatesRange form={form} />
    </>
  )
}

export default UsedTimeoffFields
